import React, { Component } from "react";
import {
  DebugAlert,
  Class,
  Interface,
  Abstract,
  ObjectTypes,
  JSTypeOperator,
} from "../../GenericCoreGraph/ClassFramework/Class";
import TObject from "../../TagComponents/TObject";
import { CommandInterfaces } from "../../GenericWebController/CommandInterpreter/cCommandInterpreter";
import Actions from "../../GenericWebController/ActionGraph/Actions";
import GenericWebGraph from "../../GenericWebController/GenericWebGraph";
import TLoginPageModal from "../Pages/GlobalPages/Modals/TLoginPageModal";

var TOpenLoginModal = Class(
  TObject,
  CommandInterfaces.IOpenLoginModalCommandReceiver,
  {
    ObjectType: ObjectTypes.Get("TOpenLoginModal"),

    constructor: function (_Props) {
      TOpenLoginModal.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        Modal: false,
      };
    },
    Destroy: function () {
      TOpenLoginModal.BaseObject.Destroy.call(this);
    },
    Receive_OpenLoginModalCommand: function (_Data) {
      window.App.LoginPageModal.HandleClickOpen(null,function (_isLogined) {

      });
    },
    render: function () {
      return (
        <div>

        </div>
      );
    },
  },
  {}
);

export default TOpenLoginModal;
